import * as React from "react";

import { cn } from "@/core/utils/func/cn";

// Filtrage UX uniquement (confort de saisie) — ce n'est PAS un contrôle de
// sécurité : la protection contre l'injection SQL relève du backend.
const preventSqlInjectionPattern = /['";`\\()=<>%]|--/g;

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onChange, ...props }, ref) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // type="file" : value est en lecture seule (sauf ""). Le filtre SQL
      // cassait la sélection (chemin C:\fakepath\… → SecurityError / clear)
      // et l'upload KYC restait vide (« Sélectionnez un fichier… »).
      if (type === "file") {
        onChange?.(e);
        return;
      }

      const cleaned = e.target.value.replace(preventSqlInjectionPattern, "");
      e.target.value = cleaned;

      onChange?.(e);
    };
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 text-foreground",
          className
        )}
        onChange={handleChange}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = "Input";

export { Input };
